// import Swiper from "swiper/bundle";
import Swiper, { Navigation, Pagination, Keyboard, Autoplay } from 'swiper'

Swiper.use([Navigation, Pagination, Keyboard, Autoplay])

/*
 * Home slider
 */

new Swiper('.c-swiper-container', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    speed: 300,

    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },

    // If we need pagination
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        dynamicBullets: true,
        dynamicMainBullets: 1,
        clickable: true,
    },

    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },

    keyboard: {
        enabled: true,
        onlyInViewport: true,
    },
})

new Swiper('.c-testimonie_wrapper', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    speed: 300,

    // If we need pagination
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        dynamicBullets: true,
        dynamicMainBullets: 1,
        clickable: true,
    },

    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },

    keyboard: {
        enabled: true,
        onlyInViewport: true,
    },
})
